// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"99db542b","471":"99db542b","696":"fc44a3bc","1572":"fc44a3bc","9239":"fc44a3bc","9925":"c8b141a9"}[chunkId] + ".chunk.css";
};